// extracted by mini-css-extract-plugin
export default {"textContainer":"main_textContainer__sKW3a","closeButton":"main_closeButton__voCX2","logoutButton":"main_logoutButton__Cqe87","btnContainer":"main_btnContainer__WE3Fk"};